import React, { useState, useEffect, useRef } from 'react'
import { Button, Card, Modal, Form, Input } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { paginationInit, formatMessageNew, downLoadFileBlob, initValueAndLabel, uniqueFun } from '@/utils/common'
import { modalConfirm, modalError, messageModal } from '@/utils/modalUtils'
import { hasPermission } from '@/annotations/nike-react'
import {
  findNddcStoreConfigurationPage,
  saveNddcStoreConfiguration,
  disableOrActiveNddcStoreConfiguration,
  exportNddcStoreConfiguration,
  findNddcStoreConfigurationDropDown
} from '@/services/rfid/rfidConfig/nddcStore'
import SearchBar from '@/components/searchbar/SearchBar'
import AntdTable from '@/components/table/AntdTable'
const menuPerm = 'menu_rfid_configuration_nddcStoreConfig'

const DROP_TYPE = {
  storeCodeList: 0,
  storeNameList: 1,
  platformTypeList: 2,
  sapStoreCodeList: 3,
  shipToList: 4,
  inventoryEntityCodeList: 5
}

const NddcStoreConfigPage = () => {
  const [newModalForm] = Form.useForm()
  const [tableList, setTableList] = useState([])
  const [queryFlag, setQueryFlag] = useState(false)
  const [pagination, setPagination] = useState(paginationInit)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [visibleFlag, setVisibleFlag] = useState(false)
  const mounting = useRef(false)
  const formRef = useRef(null)
  const editItemInfo = useRef({})

  const searchListInit = [
    {
      type: 'select',
      label: 'languageObj.nddcStoreConfig.storeCode',
      key: 'storeCodeList',
      allowClear: true,
      mode: 'multiple',
      maxTagCount: 1,
      initialValues: [],
      selectList: [],
      spans: { xl: 8, xxl: 8 }
    },
    {
      type: 'select',
      label: 'languageObj.nddcStoreConfig.storeName',
      key: 'storeNameList',
      allowClear: true,
      mode: 'multiple',
      maxTagCount: 1,
      initialValues: [],
      selectList: [],
      spans: { xl: 8, xxl: 8 }
    },
    {
      type: 'select',
      label: 'languageObj.nddcStoreConfig.platformType',
      key: 'platformTypeList',
      allowClear: true,
      mode: 'multiple',
      maxTagCount: 1,
      initialValues: [],
      selectList: [],
      spans: { xl: 8, xxl: 8 }
    },
    {
      type: 'select',
      label: 'languageObj.nddcStoreConfig.sapStoreCode',
      key: 'sapStoreCodeList',
      allowClear: true,
      mode: 'multiple',
      maxTagCount: 1,
      initialValues: [],
      selectList: [],
      spans: { xl: 8, xxl: 8 }
    },
    {
      type: 'select',
      label: 'languageObj.commonLocale.shipTo',
      key: 'shipToList',
      allowClear: true,
      mode: 'multiple',
      maxTagCount: 1,
      initialValues: [],
      selectList: [],
      spans: { xl: 8, xxl: 8 }
    },
    {
      type: 'select',
      label: 'languageObj.nddcStoreConfig.inventoryEntityCode',
      key: 'inventoryEntityCodeList',
      allowClear: true,
      mode: 'multiple',
      maxTagCount: 1,
      initialValues: [],
      selectList: [],
      spans: { xl: 8, xxl: 8 }
    }
  ]
  const [searchList, setSearchList] = useState(searchListInit)

  const addAndEditRecord = record => {
    setVisibleFlag(true)
    if (record && record.id) {
      editItemInfo.current = record
      newModalForm.setFieldsValue({
        storeCode: record.storeCode,
        storeName: record.storeName,
        platformType: record.platformType,
        sapStoreCode: record.sapStoreCode,
        shipTo: record.shipTo,
        inventoryEntityCode: record.inventoryEntityCode,
        senderAddress: record.senderAddress
      })
    } else {
      editItemInfo.current = {}
      newModalForm.resetFields()
    }
  }

  const tableColumns = [
    { title: formatMessageNew('languageObj.nddcStoreConfig.storeCode'), dataIndex: 'storeCode', width: 120 },
    {
      title: formatMessageNew('languageObj.nddcStoreConfig.inventoryEntityCode'),
      dataIndex: 'inventoryEntityCode',
      width: 240
    },
    { title: formatMessageNew('languageObj.nddcStoreConfig.storeName'), dataIndex: 'storeName', width: 140 },
    { title: formatMessageNew('languageObj.nddcStoreConfig.platformType'), dataIndex: 'platformType', width: 160 },
    { title: formatMessageNew('languageObj.nddcStoreConfig.sapStoreCode'), dataIndex: 'sapStoreCode', width: 160 },
    { title: formatMessageNew('languageObj.commonLocale.shipTo'), dataIndex: 'shipTo', width: 100 },
    { title: formatMessageNew('languageObj.nddcStoreConfig.senderAddress'), dataIndex: 'senderAddress', width: 160 },
    {
      title: formatMessageNew('languageObj.nddcStoreConfig.status'),
      dataIndex: 'statusName',
      width: 100
    },
    { title: formatMessageNew('languageObj.commonLocale.createTime'), dataIndex: 'createTime', width: 160 },
    { title: formatMessageNew('languageObj.commonLocale.lastUpdatedBy'), dataIndex: 'updateBy', width: 180 },
    { title: formatMessageNew('languageObj.commonLocale.lastUpdateTime'), dataIndex: 'updateTime', width: 180 },
    {
      title: formatMessageNew('languageObj.commonLocale.operation'),
      dataIndex: 'operation',
      align: 'center',
      width: 120,
      fixed: 'right',
      render: (_, record) => (
        <Button
          disabled={!hasPermission(menuPerm) || record.status !== 1}
          type="link"
          size="small"
          onClick={() => addAndEditRecord(record)}
        >
          {formatMessageNew('languageObj.commonLocale.edit')}
        </Button>
      )
    }
  ]

  useEffect(() => {
    mounting.current && searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])

  useEffect(() => {
    getSelectOptions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getSelectOptions = () => {
    findNddcStoreConfigurationDropDown().then(res => {
      const resDt = res.resultData || []
      searchListInit.forEach(item => {
        const typeNum = DROP_TYPE[item.key]
        if (typeNum !== undefined) {
          const arr = resDt.find(d => d.type === typeNum) || { value: [] }
          item.selectList = initValueAndLabel(uniqueFun(arr.value, 2))
        }
      })
      setSearchList([...searchListInit])
    })
  }

  const getParams = () => {
    return (formRef.current && formRef.current.getSearchValue()) || {}
  }

  const downLoadFun = () => {
    const filters = getParams()
    exportNddcStoreConfiguration({
      ...filters
    }).then(res => {
      downLoadFileBlob(res)
    })
  }

  const searchDataBtn = () => {
    mounting.current = true
    const pg = { ...pagination, currentPage: 1 }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }

  const searchClearDataBtn = () => {
    mounting.current = true
    formRef.current && formRef.current.clearForm()
    setSelectedRowKeys([])
    const pg = { ...pagination, currentPage: 1 }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }

  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }

  const searchDataFun = () => {
    setSelectedRowKeys([])
    const params = {
      pageNo: pagination.currentPage,
      size: pagination.pageSize,
      ...getParams()
    }
    findNddcStoreConfigurationPage(params).then(res => {
      const dt = res.resultData || {}
      setTableList(dt.records || [])
      const pg = {
        ...pagination,
        total: dt.total
      }
      setPagination(pg)
    })
  }

  const getSelectedRecord = () => {
    if (selectedRowKeys.length === 0) {
      modalError({ content: formatMessageNew('languageObj.nddcStoreConfig.selectData') })
      return null
    }
    return tableList.find(item => item.id === selectedRowKeys[0]) || null
  }
  const onDisableOrActive = () => {
    const record = getSelectedRecord()
    if (!record) return
    modalConfirm(
      {
        content:
          record?.status !== 1
            ? formatMessageNew('languageObj.nddcStoreConfig.activeConfirm')
            : formatMessageNew('languageObj.nddcStoreConfig.disableConfirm')
      },
      () => callDisableOrActive(record, record?.status === 1 ? 0 : 1)
    )
  }
  const callDisableOrActive = (record, targetStatus) => {
    disableOrActiveNddcStoreConfiguration({ id: record.id, status: targetStatus }).then(() => {
      messageModal('success', {
        content: formatMessageNew('languageObj.commonLocale.success')
      })
      setSelectedRowKeys([])
      setQueryFlag(!queryFlag)
    })
  }

  const handleOk = () => {
    newModalForm
      .validateFields()
      .then(values => {
        const baseParams = { ...values }
        const params = editItemInfo.current.id ? { id: editItemInfo.current.id, ...baseParams } : baseParams
        saveNddcStoreConfiguration(params)
          .then(() => {
            messageModal('success', {
              content: formatMessageNew('languageObj.commonLocale.success')
            })
            setQueryFlag(!queryFlag)
            setVisibleFlag(false)
          })
          .catch(err => {
            const code = err.errorCode
            const msg = err.errorMessage
            modalError({
              content: formatMessageNew(`languageObj.nddcStoreConfig.errorcode_${code}`) || msg
            })
          })
      })
      .catch(() => {})
  }

  const handleCancel = () => {
    setVisibleFlag(false)
  }

  const onSelectChange = keys => {
    setSelectedRowKeys(keys)
  }

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
    fixed: 'left',
    columnWidth: 50,
    onChange: onSelectChange
  }

  const hasSelected = selectedRowKeys.length > 0
  const selectedRecord = hasSelected ? tableList.find(r => r.id === selectedRowKeys[0]) : null

  const formItemRule = labelKey => [
    {
      required: true,
      message: `${formatMessageNew('languageObj.commonLocale.placeholderInput')} ${formatMessageNew(labelKey)}`
    }
  ]

  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        <div className="search-bar">
          <SearchBar
            ref={formRef}
            searchList={searchList}
            showCollapseBtn={false}
            showSearchBtn={true}
            showClearBtn={true}
            onSearch={searchDataBtn}
            onClear={searchClearDataBtn}
          />
        </div>
        <div className="displayFlex alignCenter justifyContentSB mt10">
          {hasPermission(menuPerm) ? (
            <div className="displayFlex alignCenter">
              <Button type="primary" className="ml16" onClick={() => addAndEditRecord()}>
                <PlusOutlined />
                {formatMessageNew('languageObj.commonLocale.addNew')}
              </Button>
              <Button
                type="primary"
                danger={selectedRecord && selectedRecord.status === 1}
                disabled={!hasSelected}
                className="ml20"
                onClick={onDisableOrActive}
              >
                {selectedRecord && selectedRecord.status !== 1
                  ? formatMessageNew('languageObj.commonLocale.enable')
                  : formatMessageNew('languageObj.commonLocale.disable')}
              </Button>
            </div>
          ) : (
            <div className="auto-mt20"></div>
          )}
        </div>
        <div className="content-container overflow_visible">
          <AntdTable
            rowKey={record => record.id}
            dataSource={tableList}
            onDownload={downLoadFun}
            columns={tableColumns}
            pagination={pagination}
            onChange={handleTableChange}
            rowSelection={hasPermission(menuPerm) && rowSelection}
            columnsKey="columns_nddcStoreConfig"
          />
        </div>
      </Card>
      <Modal
        open={visibleFlag}
        maskClosable={false}
        className="nike_modal"
        width="50%"
        title={
          editItemInfo.current.id
            ? formatMessageNew('languageObj.commonLocale.edit')
            : formatMessageNew('languageObj.commonLocale.addNew')
        }
        onOk={handleOk}
        onCancel={handleCancel}
        destroyOnClose
      >
        <Form form={newModalForm} labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} initialValues={{}}>
          <Form.Item
            name="storeCode"
            label={formatMessageNew('languageObj.nddcStoreConfig.storeCode')}
            rules={formItemRule('languageObj.nddcStoreConfig.storeCode')}
          >
            <Input
              placeholder={formatMessageNew('languageObj.commonLocale.placeholderInput')}
              disabled={!!editItemInfo.current.id}
            />
          </Form.Item>
          <Form.Item
            name="inventoryEntityCode"
            label={formatMessageNew('languageObj.nddcStoreConfig.inventoryEntityCode')}
            rules={formItemRule('languageObj.nddcStoreConfig.inventoryEntityCode')}
          >
            <Input
              placeholder={formatMessageNew('languageObj.commonLocale.placeholderInput')}
              disabled={!!editItemInfo.current.id}
            />
          </Form.Item>
          <Form.Item
            name="storeName"
            label={formatMessageNew('languageObj.nddcStoreConfig.storeName')}
            rules={formItemRule('languageObj.nddcStoreConfig.storeName')}
          >
            <Input placeholder={formatMessageNew('languageObj.commonLocale.placeholderInput')} />
          </Form.Item>
          <Form.Item
            name="platformType"
            label={formatMessageNew('languageObj.nddcStoreConfig.platformType')}
            rules={formItemRule('languageObj.nddcStoreConfig.platformType')}
          >
            <Input placeholder={formatMessageNew('languageObj.commonLocale.placeholderInput')} />
          </Form.Item>
          <Form.Item
            name="sapStoreCode"
            label={formatMessageNew('languageObj.nddcStoreConfig.sapStoreCode')}
            rules={formItemRule('languageObj.nddcStoreConfig.sapStoreCode')}
          >
            <Input placeholder={formatMessageNew('languageObj.commonLocale.placeholderInput')} />
          </Form.Item>
          <Form.Item name="shipTo" label={formatMessageNew('languageObj.commonLocale.shipTo')}>
            <Input placeholder={formatMessageNew('languageObj.commonLocale.placeholderInput')} />
          </Form.Item>

          <Form.Item name="senderAddress" label={formatMessageNew('languageObj.nddcStoreConfig.senderAddress')}>
            <Input placeholder={formatMessageNew('languageObj.commonLocale.placeholderInput')} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}

export default NddcStoreConfigPage
